<div *ngIf="loadReady" class="d-flex flex-column h-100" >
    <header class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-4">
            <button (click)="goBack()">
                <svg
                width="12"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M5.71 1.28906L1 5.99906L5.71 10.7091M1.5652 5.99906H13.4344"
                    stroke="#17171A"
                    stroke-opacity="0.9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                </svg>
            </button>
            <div>
                <h2 class="mb-1">{{selectedSubstationTemplate.className}}</h2>
                <p class="my-0">Substation</p>
            </div>
        </div>
        <div class="d-flex gap-3">
            <button 
            type="button"
            (click)="openSchematicModal()"
            >
                {{ "UTILITY_MANAGEMENT.PREVIEW_SCHEMATIC" | translate }}
            </button>
            <button *ngIf="permissionsService.isNetworkStructureCreateEditAllowed" class="edit__btn" (click)="onEdit()">Edit</button>
            <button *ngIf="permissionsService.isNetworkStructureDeleteAllowed" [disabled]="!isDeleteEnabled" class="delete__btn" data-bs-toggle="modal" data-bs-target="#deleteModal">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5V5ZM21.25 6.5C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5V6.5ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75H10.5ZM9 16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25H9ZM15 10.75C15 10.3358 14.6642 10 14.25 10C13.8358 10 13.5 10.3358 13.5 10.75H15ZM13.5 16.25C13.5 16.6642 13.8358 17 14.25 17C14.6642 17 15 16.6642 15 16.25H13.5ZM15.1477 5.93694C15.2509 6.33808 15.6598 6.57957 16.0609 6.47633C16.4621 6.37308 16.7036 5.9642 16.6003 5.56306L15.1477 5.93694ZM4.00156 5.79829L4.82047 18.4914L6.31736 18.3949L5.49844 5.70171L4.00156 5.79829ZM8.56269 22H15.4373V20.5H8.56269V22ZM19.1795 18.4914L19.9984 5.79829L18.5016 5.70171L17.6826 18.3949L19.1795 18.4914ZM19.25 5H4.75V6.5H19.25V5ZM2.75 6.5H4.75V5H2.75V6.5ZM19.25 6.5H21.25V5H19.25V6.5ZM15.4373 22C17.4146 22 19.0522 20.4647 19.1795 18.4914L17.6826 18.3949C17.6063 19.5788 16.6237 20.5 15.4373 20.5V22ZM4.82047 18.4914C4.94777 20.4647 6.58535 22 8.56269 22V20.5C7.37629 20.5 6.39374 19.5788 6.31736 18.3949L4.82047 18.4914ZM9 10.75V16.25H10.5V10.75H9ZM13.5 10.75V16.25H15V10.75H13.5ZM12 3.5C13.5134 3.5 14.7868 4.53504 15.1477 5.93694L16.6003 5.56306C16.0731 3.51451 14.2144 2 12 2V3.5ZM8.85237 5.93694C9.21319 4.53504 10.4867 3.5 12 3.5V2C9.78568 2 7.92697 3.51451 7.39971 5.56306L8.85237 5.93694Z" fill="#17171A" fill-opacity="0.9"/>
                </svg>
            </button>
        </div>
    </header>

    <div *ngIf="!selectedSubstationTemplate.equipmentTemplates.length" class="d-flex justify-content-center align-items-center h-100">
        <lib-network-model-no-data (equipmentOutput)="onAddEquipment()" [type]="'Equipment'" [buttonText]="'Equipment Or Connectivity'" [titleText]="'equipment & connectivity'"></lib-network-model-no-data>
    </div>

    <div *ngIf="selectedSubstationTemplate.equipmentTemplates.length" class="page-layout" [class.expanded]="isSchematicExpanded">
        <div class="sidebar">
            <div class="sidebar-header">
                <div class="d-flex align-items-center">
                    <img src="../../../../assets/icons/v3-bps/IconApiConnection.svg" />
                    <span>Equipment & Connectivity</span>
                </div>
                <button *ngIf="permissionsService.isNetworkStructureCreateEditAllowed" (click)="onAddEquipment()">Add</button>
            </div>

            <div class="sidebar-items">
                <div class="items-container">
                    <div [class.selected]="eq == selectedEquipment" *ngFor="let eq of selectedSubstationTemplate.equipmentTemplates" (click)="selectExistingEquipment(eq)" class="sidebar-item">
                        <span>{{ eq.className }}</span>
                        <img src="../../../../assets/icons/v3-bps/equipment-list-item-icon.svg" />                        
                    </div>  
                </div>
                <div *ngIf="permissionsService.isNetworkStructureCreateEditAllowed" class="button-container">
                    <button (click)="onAddEquipment()">Add Equipment/Connectivity</button>
                </div>
            </div>
        </div>

        <div class="body">
            <ng-container [ngSwitch]="selectedEquipment.cimClass">
                <lib-power-transformer-form 
                    *ngSwitchCase="'PowerTransformer'"
                    [equipment]="selectedEquipment" 
                    [substation]="selectedSubstationTemplate"
                    [editEnabled]="enableEdit"
                    [deleteClicked]="deleteClicked"
                    (equipmentChanged)="onFormChange()"
                    (saveClicked)="save($event)"
                ></lib-power-transformer-form>
                <lib-common-equipment-template
                    *ngSwitchDefault
                    [equipment]="selectedEquipment" 
                    [substation]="selectedSubstationTemplate"
                    [editEnabled]="enableEdit"
                    [deleteClicked]="deleteClicked"
                    (equipmentChanged)="onFormChange()"
                    (saveClicked)="save($event)"
                ></lib-common-equipment-template>
            </ng-container>
        </div>

        <div class="schematic">
            <div class="schematic-icon">
                <button
                    style="border: 0; background-color: transparent;"
                    [disabled]="isSchematicExpanded"
                    (click)="!isSchematicExpanded && toggleSchematic()"
                >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.875 6.1875C5.80698 6.1875 6.5625 5.43198 6.5625 4.5C6.5625 3.56802 5.80698 2.8125 4.875 2.8125C3.94302 2.8125 3.1875 3.56802 3.1875 4.5C3.1875 5.43198 3.94302 6.1875 4.875 6.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.875 15.1875C5.80698 15.1875 6.5625 14.432 6.5625 13.5C6.5625 12.568 5.80698 11.8125 4.875 11.8125C3.94302 11.8125 3.1875 12.568 3.1875 13.5C3.1875 14.432 3.94302 15.1875 4.875 15.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.125 6.1875C14.057 6.1875 14.8125 5.43198 14.8125 4.5C14.8125 3.56802 14.057 2.8125 13.125 2.8125C12.193 2.8125 11.4375 3.56802 11.4375 4.5C11.4375 5.43198 12.193 6.1875 13.125 6.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.875 6.1875V11.8125" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.125 6.1875V7.5C13.125 8.32845 12.4534 9 11.625 9H6.375C5.54657 9 4.875 9.67155 4.875 10.5V11.8125" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <div 
                    *ngIf="isSchematicExpanded"
                    class="schematic-title"
                >
                    {{ "UTILITY_MANAGEMENT.SCHEMATIC_DIAGRAM" | translate }}
                </div>
                <span style="flex:1"></span>
                <button 
                    *ngIf="isSchematicExpanded" 
                    (click)="isSchematicExpanded && toggleSchematic()"
                    class="hide__btn"
                >
                {{ "COMMON.HIDE" | translate }}
                </button>
            </div>
        </div>
        <div class="schematic-diagram" *ngIf="isSchematicExpanded">
            <lib-expanded-schematic-diagram #cyto [equipmentList]="equipmentList" [substationTemplateId]="id"></lib-expanded-schematic-diagram>
        </div>
    </div>


    <div *ngIf="equipmentPopupOpened" class="add-equipment-popup">
        <div class="popup-header d-flex justify-content-between align-items-center">
            <h4>Add Connectivity/Equipments</h4>
            <span (click)="closePopup()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.94028 8.00012L13.1403 3.80679C13.2658 3.68125 13.3363 3.51099 13.3363 3.33346C13.3363 3.15592 13.2658 2.98566 13.1403 2.86012C13.0147 2.73459 12.8445 2.66406 12.667 2.66406C12.4894 2.66406 12.3192 2.73459 12.1936 2.86012L8.00028 7.06012L3.80695 2.86012C3.68142 2.73459 3.51115 2.66406 3.33362 2.66406C3.15608 2.66406 2.98582 2.73459 2.86028 2.86012C2.73475 2.98566 2.66422 3.15592 2.66422 3.33346C2.66422 3.51099 2.73475 3.68125 2.86028 3.80679L7.06028 8.00012L2.86028 12.1935C2.7978 12.2554 2.7482 12.3292 2.71436 12.4104C2.68051 12.4916 2.66309 12.5788 2.66309 12.6668C2.66309 12.7548 2.68051 12.8419 2.71436 12.9232C2.7482 13.0044 2.7978 13.0781 2.86028 13.1401C2.92226 13.2026 2.99599 13.2522 3.07723 13.2861C3.15847 13.3199 3.24561 13.3373 3.33362 13.3373C3.42163 13.3373 3.50876 13.3199 3.59 13.2861C3.67124 13.2522 3.74498 13.2026 3.80695 13.1401L8.00028 8.94012L12.1936 13.1401C12.2556 13.2026 12.3293 13.2522 12.4106 13.2861C12.4918 13.3199 12.5789 13.3373 12.667 13.3373C12.755 13.3373 12.8421 13.3199 12.9233 13.2861C13.0046 13.2522 13.0783 13.2026 13.1403 13.1401C13.2028 13.0781 13.2524 13.0044 13.2862 12.9232C13.3201 12.8419 13.3375 12.7548 13.3375 12.6668C13.3375 12.5788 13.3201 12.4916 13.2862 12.4104C13.2524 12.3292 13.2028 12.2554 13.1403 12.1935L8.94028 8.00012Z" fill="#14213D"/>
                </svg>
            </span>
        </div>
        <div class="popup-body">
            <div class="search row">
                <div class="search-bar col-8 d-flex align-items-center justify-content-center gap-2">
                    <img height="16" width="16" src="../../../../assets/icons/search.svg" />
                    <input type="text" placeholder="Search..." [(ngModel)]="searchTerm"/>
                </div>
            </div>
            <ul class="equipment-list">
                <li class="equipment-item" *ngIf="matchesFilter(getCimLabel(CIMClass.PowerTransformer))" (click)="onSelectEquipmentType(CIMClass.PowerTransformer)">
                    {{ getCimLabel(CIMClass.PowerTransformer) }}
                </li>

                <li class="equipment-item" *ngIf="matchesFilter(getCimLabel(CIMClass.AcLineSegment))" (click)="onSelectEquipmentType(CIMClass.AcLineSegment)">
                    {{ getCimLabel(CIMClass.AcLineSegment) }}
                </li>

                <li class="equipment-group" [class.expanded]="connectorExpanded" (click)="connectorExpanded = !connectorExpanded">
                    <div  class="line">
                        <div class="group-title">
                            <div class="group-header">Connector</div>
                            <div class="group-subheader">• 2 Types</div>
                        </div>
                        <span class="icon">
                            <span *ngIf="connectorExpanded">
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                            <span *ngIf="!connectorExpanded" >
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                        </span>
                    </div>

                    <ul *ngIf="connectorExpanded" class="sub-list">
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Busbar))" (click)="onSelectEquipmentType(CIMClass.Busbar)">
                            {{ getCimLabel(CIMClass.Busbar) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Junction))" (click)="onSelectEquipmentType(CIMClass.Junction)">
                            {{ getCimLabel(CIMClass.Junction) }}
                        </li>
                    </ul>
                </li>

                <li class="equipment-group" [class.expanded]="switchgearExpanded" (click)="switchgearExpanded = !switchgearExpanded">
                    <div class="line">
                        <div class="group-title">
                        <div class="group-header">Switchgear</div>
                        <div class="group-subheader">• 6 Types</div>
                    </div>  
                    <span class="icon">
                        <span *ngIf="switchgearExpanded">
                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z" fill="#0F0F0F"/>
                            </svg>
                        </span>
                        <span *ngIf="!switchgearExpanded" >
                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"/>
                            </svg>
                        </span>
                    </span>
                    </div>

                    <ul *ngIf="switchgearExpanded" class="sub-list">
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Jumper))" (click)="onSelectEquipmentType(CIMClass.Jumper)">
                            {{ getCimLabel(CIMClass.Jumper) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Fuse))" (click)="onSelectEquipmentType(CIMClass.Fuse)">
                            {{ getCimLabel(CIMClass.Fuse) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Disconnector))" (click)="onSelectEquipmentType(CIMClass.Disconnector)">
                            {{ getCimLabel(CIMClass.Disconnector) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.GroundDisconnector))" (click)="onSelectEquipmentType(CIMClass.GroundDisconnector)">
                            {{ getCimLabel(CIMClass.GroundDisconnector) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Breaker))" (click)="onSelectEquipmentType(CIMClass.Breaker)">
                            {{ getCimLabel(CIMClass.Breaker) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.LoadBreakSwitch))" (click)="onSelectEquipmentType(CIMClass.LoadBreakSwitch)">
                            {{ getCimLabel(CIMClass.LoadBreakSwitch) }}
                        </li>
                    </ul>
                </li>
                <li class="equipment-group" [class.expanded]="groundingAndSectioningExpanded" (click)="groundingAndSectioningExpanded = !groundingAndSectioningExpanded">
                    <div class="line">
                        <div class="group-title">
                            <div class="group-header">Grounding & Sectioning</div>
                            <div class="group-subheader">• 2 Types</div>
                        </div>
                        <span class="icon">
                            <span *ngIf="groundingAndSectioningExpanded">
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                            <span *ngIf="!groundingAndSectioningExpanded" >
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                        </span> 
                    </div>
                    <ul *ngIf="groundingAndSectioningExpanded" class="sub-list">
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Ground))" (click)="onSelectEquipmentType(CIMClass.Ground)">
                            {{ getCimLabel(CIMClass.Ground) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Cut))" (click)="onSelectEquipmentType(CIMClass.Cut)">
                            {{ getCimLabel(CIMClass.Cut) }}
                        </li>
                    </ul> 
                </li>
                <li class="equipment-group" [class.expanded]="protectionDevicesExpanded" (click)="protectionDevicesExpanded = !protectionDevicesExpanded">
                    <div class="line">
                        <div class="group-title">
                            <div class="group-header">Protection Devices</div>
                            <div class="group-subheader">• 3 Types</div>
                        </div>
                        <span class="icon">
                            <span *ngIf="protectionDevicesExpanded">
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                            <span *ngIf="!protectionDevicesExpanded" >
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                        </span> 
                    </div>
                    <ul *ngIf="protectionDevicesExpanded" class="sub-list">
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Recloser))" (click)="onSelectEquipmentType(CIMClass.Recloser)">
                            {{ getCimLabel(CIMClass.Recloser) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.Sectionaliser))" (click)="onSelectEquipmentType(CIMClass.Sectionaliser)">
                            {{ getCimLabel(CIMClass.Sectionaliser) }}
                        </li>
                    </ul>
                </li>
                <li class="equipment-group" [class.expanded]="comensationEquipmentExpanded" (click)="comensationEquipmentExpanded = !comensationEquipmentExpanded">
                    <div class="line">
                        <div class="group-title">
                            <div class="group-header">Compensation Equipment</div>
                            <div class="group-subheader">• 4 Types</div>
                        </div>
                        <span class="icon">
                            <span *ngIf="comensationEquipmentExpanded">
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                            <span *ngIf="!comensationEquipmentExpanded" >
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"/>
                                </svg>
                            </span>
                        </span> 
                    </div> 
                    <ul *ngIf="comensationEquipmentExpanded" class="sub-list">
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.PetersenCoil))" (click)="onSelectEquipmentType(CIMClass.PetersenCoil)">
                            {{ getCimLabel(CIMClass.PetersenCoil) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.ShuntCompensator))" (click)="onSelectEquipmentType(CIMClass.ShuntCompensator)">
                            {{ getCimLabel(CIMClass.ShuntCompensator) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.FrequencyConverter))" (click)="onSelectEquipmentType(CIMClass.FrequencyConverter)">
                            {{ getCimLabel(CIMClass.FrequencyConverter) }}
                        </li>
                        <li class="sub-item" *ngIf="matchesFilter(getCimLabel(CIMClass.StaticVarCompensator))" (click)="onSelectEquipmentType(CIMClass.StaticVarCompensator)">
                            {{ getCimLabel(CIMClass.StaticVarCompensator) }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>

<div
  class="modal fade"
  id="deleteModal"
  tabindex="-1"
  aria-labelledby="deleteModalTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.EQUIPMENT" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-bs-dismiss="modal"
          (click)="onDelete()"
        >
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isSchematicOpen"
     class="slide-modal-backdrop"
     [class.fade-in]="!closingSchematic"
     [class.fade-out]="closingSchematic" 
     (click)="closeSchematicModal()">
    <div class="slide-modal"     
        [class.slide-in]="!closingSchematic"
        [class.slide-out]="closingSchematic"
        (click)="$event.stopPropagation()">
        <div class="slide-modal-header">
            <div class="schematic-diagram-modal-title">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.875 6.1875C5.80698 6.1875 6.5625 5.43198 6.5625 4.5C6.5625 3.56802 5.80698 2.8125 4.875 2.8125C3.94302 2.8125 3.1875 3.56802 3.1875 4.5C3.1875 5.43198 3.94302 6.1875 4.875 6.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.875 15.1875C5.80698 15.1875 6.5625 14.432 6.5625 13.5C6.5625 12.568 5.80698 11.8125 4.875 11.8125C3.94302 11.8125 3.1875 12.568 3.1875 13.5C3.1875 14.432 3.94302 15.1875 4.875 15.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.125 6.1875C14.057 6.1875 14.8125 5.43198 14.8125 4.5C14.8125 3.56802 14.057 2.8125 13.125 2.8125C12.193 2.8125 11.4375 3.56802 11.4375 4.5C11.4375 5.43198 12.193 6.1875 13.125 6.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.875 6.1875V11.8125" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.125 6.1875V7.5C13.125 8.32845 12.4534 9 11.625 9H6.375C5.54657 9 4.875 9.67155 4.875 10.5V11.8125" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ "UTILITY_MANAGEMENT.SCHEMATIC_DIAGRAM" | translate }}
            </div>
            <button
            type="button"
            (click)="closeSchematicModal()"
            style="border: 0; background-color: transparent;"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033L8.9393 10L6.46967 12.4697C6.17678 12.7626 6.17678 13.2374 6.46967 13.5303C6.76256 13.8232 7.23744 13.8232 7.53033 13.5303L10 11.0607L12.4697 13.5303C12.7626 13.8232 13.2374 13.8232 13.5303 13.5303C13.8232 13.2374 13.8232 12.7626 13.5303 12.4697L11.0607 10L13.5303 7.53033C13.8232 7.23744 13.8232 6.76256 13.5303 6.46967C13.2374 6.17678 12.7626 6.17678 12.4697 6.46967L10 8.9393L7.53033 6.46967Z" fill="#171717"/>
                </svg>
            </button>
        </div>
        <div class="slide-modal-body">
            <lib-preview-schematic-diagram [substationList]="substationTemplates"></lib-preview-schematic-diagram>
        </div>
    </div>
</div>